/**
 * How the rules reach data at a match's balance version (Phase 7). The simulation never reads
 * the global catalogs: every weapon and mech comes from `MatchStatic`, which `buildMatchStatic`
 * fills from the setup's balance document (or the built-in data), so a client and the server
 * that received the same document agree tick for tick.
 */
import { builtInCatalog, effectiveCatalog } from '../data/index.js';
/** Magazine sizes for every weapon (null = no magazine), resolved once per match. */
export function magazineSizes(weapons) {
    const out = new Map();
    for (const w of Object.values(weapons))
        out.set(w.id, w.magazine?.size ?? null);
    return out;
}
/** A weapon at the match's balance version; an unknown id is a data error, never a default. */
export function weaponOf(ctx, id) {
    const def = ctx.weapons[id];
    if (!def)
        throw new Error(`unknown weapon "${id}"`);
    return def;
}
/** The melee weapon a mech swings on F (DECISIONS.md #15), at the match's balance version. */
export function meleeWeaponFor(ctx, def) {
    return weaponOf(ctx, def.melee ?? ctx.balance.melee.defaultWeapon);
}
/** The catalog a setup names: its balance document, or the built-in data. */
export function catalogOf(setup) {
    return setup.balance
        ? effectiveCatalog(setup.balance.overrides, setup.balance.version)
        : builtInCatalog();
}
//# sourceMappingURL=catalog.js.map